import { render } from "./GenerateContractFieldsModal.vue?vue&type=template&id=161968d8&scoped=true&ts=true&lang=pug"
import script from "./GenerateContractFieldsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./GenerateContractFieldsModal.vue?vue&type=script&lang=ts&setup=true"

import "./GenerateContractFieldsModal.vue?vue&type=style&index=0&id=161968d8&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161968d8"]])

export default __exports__